<div class="stepper-bar">
    <div class="stepper-bar-step" *ngFor="let name of stepNames; let i = index; last as isLast" [ngClass]="{'stepper-bar-step-selected': currentStep === i+1, 'stepper-bar-step-done': i < currentStep-1}">
        <ng-container [ngTemplateOutlet]="stepperBarStep" [ngTemplateOutletContext]="{ name: name, number: i+1, isLast: isLast }"></ng-container>
    </div>
</div>

<ng-template
  #stepperBarStep
  let-name="name"
  let-number="number"
  let-last="isLast"
>
    <div class="stepper-bar-step-circle"></div>
    <div class="stepper-bar-step-info">
        <span class="stepper-bar-step-info-number">{{'STEPBAR.STEP' | translate}} {{number}}</span>
        <span class="stepper-bar-step-info-name">{{name}}</span>
    </div>
    
    <div *ngIf="!last" class="stepper-bar-step-line"></div>
</ng-template>